<template>
    <div class="w-full flex flex-col p-8 text-ternary">
        <div class="flex justify-end mt-2">
            <div @click.stop="openDocumentModal"
                class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                Apply</div>
        </div>
        <div v-if="item.partner" class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Employer</div>
            <div class="w-3/4">{{ item.partner.en_company_name }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Title</div>
            <div class="w-3/4">{{ item.title }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Description</div>
            <div class="w-3/4">{{ item.description }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Trainer Information</div>
            <div class="w-3/4" v-html="item.trainer_information"></div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Start Date</div>
            <div class="w-3/4">{{ getFormattedDate(item.start_date) }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">End Date</div>
            <div class="w-3/4">{{ getFormattedDate(item.end_date) }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Location</div>
            <div class="w-3/4">{{ item.location }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Entity</div>
            <div class="w-3/4">{{ item.entity }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Duration</div>
            <div class="w-3/4">{{ item.duration }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Prerequisites</div>
            <div class="w-3/4">{{ item.prerequisites }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Additional Information</div>
            <div class="w-3/4">{{ item.additional_information }}</div>
        </div>

        <transition name="fade" mode="out-in">
            <base-modal v-if="showUploadDocumentModal" :title="`Upload Documents`" height="" @close="closeModal">
                <upload-documents @document-submit="onDocumentSubmit" @close="closeModal"></upload-documents>
            </base-modal>
        </transition>

        <div class="h-full flex justify-center items-center" v-if="isLoading">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>

    </div>
</template>

<script>
import { formattedDate } from "../../../helpers/utils";
import gql from 'graphql-tag';
import UploadDocuments from "./upload-documents.vue";
export default {
    name: "post-training-view",
    props: ["item"],
    emits: ["close"],
    components: {
        UploadDocuments,
    },
    data() {
        return {
            isLoading: false,
            showUploadDocumentModal: false,
        }
    },
    methods: {
        getFormattedDate(date) {
            return formattedDate(date);
        },
        openDocumentModal() {
            this.showUploadDocumentModal = true;
        },
        closeModal() {
            this.showUploadDocumentModal = false;
        },
        onDocumentSubmit(documents) {
            // this.showUploadDocumentModal = false;
            this.documents = documents;
            this.applyForPostTraining();
        },
        async applyForPostTraining() {
            this.isLoading = true;

            const CREATE_MUTATION = gql`
                mutation ApplyForPostTraining($token: String!, $uploaded_documents: [Upload]!) {
                    applyForPostTraining(token: $token, uploaded_documents: $uploaded_documents) {
                        error
                        message
                    }
                }
            `;

            let error_msg = null;
            let success_msg = null;

            try {
                await this.$apollo.mutate({
                    mutation: CREATE_MUTATION,
                    variables: {
                        token: this.item.token,
                        uploaded_documents: this.documents,
                    },
                    context: {
                        headers: {
                            'content-type': 'multipart/form-data',
                        },
                    },
                }).then((data) => {
                    if (data.data.applyForPostTraining.error) {
                        error_msg = data.data.applyForPostTraining.message;
                    } else {
                        success_msg = data.data.applyForPostTraining.message;
                    }
                }).catch((error) => {
                    console.log(error)
                    error_msg = error.message;
                })

            } catch (error) {
                console.log(error);
                error_msg = error.message || "Please try again later.";
            }

            if (error_msg === null) {

                const Toast = this.$swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', this.$swal.stopTimer)
                        toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: success_msg
                })

                // this.$emit('close');

            } else {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error_msg,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        error_msg = "";
                        success_msg = "";
                    }
                })
            }

            this.isLoading = false;
        },
    },
}
</script>